<template>
  <div
    class="h-full w-full flex max-lg:flex-col lg:bg-gradient-gray-neutral overflow-y-hidden"
  >
    <div class="grow border-r border-secondary overflow-y-auto">
      <TaskBody
        :task="task"
        :canEdit="canEdit"
        :canLogTime="canLogTime"
        :canLogMaterial="canLogMaterial"
        :readonly="readonly"
        :isArchived="isArchived"
        @update="$emit('update', $event)"
        @logTime="$emit('logTime')"
        @showTimeLog="$emit('showTimeLog')"
        @logMaterial="$emit('logMaterial')"
        @showMaterialLog="$emit('showMaterialLog')"
      />
    </div>
    <TaskTabs
      v-if="!maxTablet"
      :open="!!tab || !tabsState?.collapsed"
      :tabIndex="
        { activity: 0, comments: 1, attachments: 2 }[tab || tabsState?.selected]
      "
      :task="task"
      :feed="feed"
      :attachments="attachments"
      :users="users"
      :commentsMedia="commentsMedia"
      :isArchived="isArchived"
      @update:state="updateUpdateState"
    />
  </div>
</template>

<script setup>
import { TaskBody, TaskTabs } from "@/SharedComponents/Tasks/TaskDetailsParts";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import {
  useUserPreferences,
  useUpdateTaskTabsState,
} from "@/Composables/useUserPreferences";

const { maxTablet } = useBreakpoints();

defineEmits([
  "update",
  "logTime",
  "showTimeLog",
  "logMaterial",
  "showMaterialLog",
]);

defineProps({
  tab: { type: String, required: false },
  task: { type: Object, required: true },
  feed: { type: Array, required: true },
  attachments: { type: Array, required: true },
  users: { type: Array, required: true },
  commentsMedia: { type: Array, default: () => [] },
  canEdit: { type: Boolean, default: false },
  canLogTime: { type: Boolean, default: false },
  canLogMaterial: { type: Boolean, default: false },
  isArchived: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
});

const { data: tabsState } = useUserPreferences("task_tabs");
const { mutateAsync: updateTaskTabsState } = useUpdateTaskTabsState();

function updateUpdateState(state) {
  updateTaskTabsState(state);
}
</script>
